import { loaderAction, userFormAction, photoFileAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { getUsersStatisticSagaAction } from "../sagaActions";
import { USER_FORM_INITIAL } from "../initialStateConstant";
import { getUsersThunk } from "./getUsersThunk";

export const AddNewUserThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment, usersList } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('name', args.name);
        formData.append('phone', args.phone);
        formData.append('email', args.email);
        formData.append('image', args.avatar?.file || args.avatar);
        formData.append('sex', args.sex);
        formData.append('note', args.note);
        formData.append('birthday', args.birthday);
        formData.append('additional_id', args.additional_id);
        formData.append('links', args.links);

        const response = await api({ data: formData, link: 'add_new_user' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список пользователей если он открыт
            if (usersList.length > 0) {
                dispatch(getUsersThunk({ page: 1 }));
            }

            // Закрываем форму посетителя
            dispatch(userFormAction(USER_FORM_INITIAL));
            dispatch(photoFileAction(null));
            dispatch(getUsersStatisticSagaAction({ establishment: currentEstablishment }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};